import { Stack } from '@mui/material'
import type { JSX } from 'react'

import {
  Heading4,
  TextBody,
} from '@front/components/data-display/typography/Typography'
import {
  AppButton,
  type AppButtonProps,
} from '@front/components/inputs/app-button'
import { Separator } from '@front/components/layout/separator'

type EmptyStateProps = {
  icon: JSX.Element
  title: string
  message?: string
  button?: AppButtonProps
  'data-testid'?: string
}

export const EmptyState = ({
  icon,
  title,
  message,
  button,
  'data-testid': dataTestId,
}: EmptyStateProps): JSX.Element => (
  <Stack
    data-testid={dataTestId}
    sx={{
      alignItems: 'center',
      width: '100%',
      textAlign: 'center',
      p: 3,

      '& > svg': {
        width: 32,
        height: 32,
        color: 'text.secondary',
      },
    }}
  >
    {icon}
    <Separator size="S" />
    <Heading4 color="secondary" role="presentation">
      {title}
    </Heading4>
    {message != null && (
      <>
        <Separator size="XS" />
        <TextBody color="secondary">{message}</TextBody>
      </>
    )}
    {button != null && (
      <>
        <Separator size="M" />
        <AppButton size="small" {...button} />
      </>
    )}
  </Stack>
)
